import { useCallback } from 'react';
import { useProjectStore, type AnalysisResult } from '../store/projectStore';
import type { AnalyzeReferencesInput } from '../lib/aiAnalyzer';

export interface UseAIAnalysisReturn {
  loading: boolean;
  error: string | null;
  result: AnalysisResult | null;
  analyze: (input: AnalyzeReferencesInput) => Promise<void>;
  reset: () => void;
}

export function useAIAnalysis(): UseAIAnalysisReturn {
  const loading = useProjectStore((state) => state.analysisLoading);
  const error = useProjectStore((state) => state.analysisError);
  const result = useProjectStore((state) => state.analysisResult);
  const analyzeReferences = useProjectStore((state) => state.analyzeReferences);

  const analyze = useCallback(async (input: AnalyzeReferencesInput) => {
    await analyzeReferences(input);
  }, [analyzeReferences]);

  const reset = useCallback(() => {
    // Reset is intentionally a no-op when backed by global store state,
    // since the analysis result is shared across tabs. Consumers can
    // navigate back to reference/start and trigger a new analysis instead.
  }, []);

  return {
    loading,
    error,
    result,
    analyze,
    reset,
  };
}
